import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Customer } from '@pos-app/data';
import { CoreUiPartialState, clearSearchData } from '@pos-app/core-ui';
import { Store } from '@ngrx/store';
import { CoreUiModule } from '../../../../../../../../libs/core-ui/src/lib/core-ui.module';

@Component({
    selector: 'app-customers-search',
    templateUrl: './customers-search.component.html',
    styleUrls: ['./customers-search.component.scss'],
    imports: [CoreUiModule]
})
export class CustomersSearchComponent implements OnInit {
  @Input() public displayCustomerDetails: boolean = false;
  @Input() readonly: boolean = false;

  @Output() public displaySelectedCustomer = new EventEmitter<Customer>();

  constructor(private router: Router, private coreStore: Store<CoreUiPartialState>) {}

  public ngOnInit(): void {
    this.coreStore.dispatch(clearSearchData());
  }

  public selectCustomer(customer: Customer): void {
    if (customer) {
      if (!this.displayCustomerDetails) {
        this.router.navigate(['pos/customers/' + customer.customerNumber + '/details']);
      } else {
        this.displaySelectedCustomer.emit(customer);
      }
    }
  }
}

